import { render, staticRenderFns } from "./BooksFilters.vue?vue&type=template&id=0dbd63ae"
import script from "./BooksFilters.vue?vue&type=script&lang=js"
export * from "./BooksFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports